module.exports = __webpack_public_path__ + "img/SC8-occupation.f96991a9.svg";